import React from 'react'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const LeftInfoPanel = ({ orgName }) => (
  <Grid item xs={12}>
    <Stack justifyContent="space-between" flex={1} gap={1}>
      <Typography variant="body1" align="justify">
        To securely view a patient’s care record following a recent interaction
        with {orgName}, please use the share code you have been provided with.
        This code ensures that only authorised individuals can access the
        record. Please note that all access is logged and monitored to maintain
        strict confidentiality and compliance with data protection regulations.
      </Typography>
      <Alert severity="error" icon={false}>
        The information contained herein is privileged and confidential and is
        protected by UK Data Protection laws, including the Data Protection Act
        2018, and the Computer Misuse Act 1990. Any unauthorised access,
        disclosure, distribution, or use of this software is strictly
        prohibited.
      </Alert>
    </Stack>
  </Grid>
)

export default LeftInfoPanel
